
// import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";

// const App = ({ goToTab }) => {
//   return (
//     <div className="container-fluid ">
//       <div className="table-responsive">
//         <table className="table">
//           <thead>
//             <tr>
//               <th>Sr.No</th>

//               <th>Name</th>
//               <th>Relation</th>

//               <th>D.O.B</th>
//               <th>Gender</th>
//               <th>Married</th>
//               <th>Employed</th>
//               <th>Occupation</th>
//               <th>Dependent</th>
//               <th>PF Nominee</th>
//               <th>% PF Share</th>
//               <th></th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr>
//               <td>
//                 <input type="text" className="form-control" />
//               </td>
//               {/* <td>
//         <input type="text" className="form-control" />
//       </td> */}
//               <td>
//                 <select className="form-select">
//                   <option>Select</option>
//                 </select>
//                 <input
//                   type="text"
//                   className="form-control"
//                   placeholder="First Name"
//                 />
//                 <input
//                   type="text"
//                   className="form-control"
//                   placeholder="Second Name"
//                 />
//                 <input
//                   type="text"
//                   className="form-control"
//                   placeholder="Last Name"
//                 />
//               </td>
//               <td>
//                 <input type="text" className="form-control" />
//               </td>

//               <td>
//                 <input type="date" className="form-control" />
//               </td>
//               <td>
//                 <select className="form-select">
//                   <option>Select</option>
//                 </select>
//               </td>
//               <td>
//                 <select className="form-select">
//                   <option>Select</option>
//                 </select>
//               </td>
//               <td>
//                 <div className="form-check">
//                   <input
//                     type="radio"
//                     className="form-check-input"
//                     name="dependent"
//                   />
//                   <label className="form-check-label">Yes</label>
//                 </div>
//                 <br></br>
//                 <div className="form-check">
//                   <input
//                     type="radio"
//                     className="form-check-input"
//                     name="dependent"
//                   />
//                   <label className="form-check-label">No</label>
//                 </div>
//               </td>
//               <td>
//                 <input type="text" className="form-control" />
//               </td>
//               <td>
//                 <div className="form-check">
//                   <input
//                     type="radio"
//                     className="form-check-input"
//                     name="dependent"
//                   />
//                   <label className="form-check-label">Yes</label>
//                 </div>
//                 <br></br>
//                 <div className="form-check">
//                   <input
//                     type="radio"
//                     className="form-check-input"
//                     name="dependent"
//                   />
//                   <label className="form-check-label">No</label>
//                 </div>
//               </td>
//               <td>
//                 <div className="form-check">
//                   <input
//                     type="radio"
//                     className="form-check-input"
//                     name="dependent"
//                   />
//                   <label className="form-check-label">Yes</label>
//                 </div>
//                 <br></br>
//                 <div className="form-check">
//                   <input
//                     type="radio"
//                     className="form-check-input"
//                     name="dependent"
//                   />
//                   <label className="form-check-label">No</label>
//                 </div>
//               </td>
//               <td>
//                 <input type="text" className="form-control" />
//               </td>
//               <td>
//                 <button className="btn btn-primary">Add</button>{" "}
//                 {/* Add button */}
//               </td>
//             </tr>
//           </tbody>
//         </table>
//       </div>
//       <div className="d-flex justify-content-end mb-3">
//         <button className="btn btn-primary border" onClick={() => goToTab(4)}>
//           Next
//         </button>
//       </div>
//     </div>
//   );
// };

// export default App;





import React, { useState ,useEffect} from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { ApiUrl } from "../../../ApiUrl";

const App = ({ goToTab, relationDetails , setEducationDetailsInParent }) => {
  const [formData, setFormData] = useState({
    srNo: "",
    name: { first: "", second: "", last: "", title: "Select" },
    relation: "",
    dob: "",
    gender: "Select",
    married: "Select",
    employed: "",
    occupation: "",
    dependent: "",
    pfNominee: "",
    pfShare: "",
  });

  const [dataList, setDataList] = useState([]);
  const [validationError, setValidationError] = useState("");

  const normalizePfNomineeValue = (value) => {
    if (value === "T" || value === "Y" || value === true) return "T";
    if (value === "F" || value === "N" || value === false) return "F";
    return "";
  };

  const formatPfNominee = (value) => {
    const normalized = normalizePfNomineeValue(value);
    if (normalized === "T") return "Yes";
    if (normalized === "F") return "No";
    return "";
  };

  const isFutureDate = (value) => {
    if (!value) return false;
    const enteredDate = new Date(value);
    if (Number.isNaN(enteredDate.getTime())) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return enteredDate > today;
  };

  const isValidPfShare = (value) => {
    if (value === "" || value === null || value === undefined) {
      return true;
    }

    const numeric = Number(value);
    return !Number.isNaN(numeric) && numeric >= 0 && numeric <= 100;
  };
useEffect(() => {
  if (relationDetails && relationDetails.length > 0) {
    const formatted = relationDetails.map((item, index) => ({
      srNo: index + 1,
      name: {
        title: item.relation_title || " ",
        first: item.relation_first_name || "",
        second: item.relation_second_name || "",
        last: item.relation_last_name || "",
      },
      relation: item.emp_relation || "",
      dob: item.relation_dob || "",
      gender: item.relation_gender || "Select",
      married: item.relation_marital_status || "Select",
      employed: item.relation_employed || "",
      occupation: item.relation_occupation || "",
      dependent: item.relation_dependent === 1 ? 1 : 0,
      pfNominee: normalizePfNomineeValue(item.relation_pf_nominee),
      pfShare: item.relation_pf_share || "",
    }));

    // Load first row into form
    setFormData(formatted[0]);

    // Push the remaining into table
    setDataList(formatted.slice(1));
  }
}, [relationDetails]);



  const handleChange = (field, value, subfield = null) => {
    if (field === "dob") {
      setValidationError(
        isFutureDate(value) ? "Family member DOB cannot be a future date." : ""
      );
    }

    if (field === "pfShare") {
      const sanitized = String(value).replace(/[^0-9.]/g, "");

      if (sanitized === "") {
        setFormData((prev) => ({ ...prev, pfShare: "" }));
        return;
      }

      const numeric = Number(sanitized);
      if (Number.isNaN(numeric) || numeric < 0 || numeric > 100) {
        alert("PF Share % cannot be more than 100.");
        return;
      }

      setFormData((prev) => ({ ...prev, pfShare: sanitized }));
      return;
    }

    if (subfield) {
      setFormData((prev) => ({
        ...prev,
        [field]: { ...prev[field], [subfield]: value },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [field]: value }));
    }
  };

  const handleAdd = () => {
    if (!formData.dob) {
      alert("Please enter DOB before adding.");
      return;
    }

    if (isFutureDate(formData.dob)) {
      setValidationError("Family member DOB cannot be a future date.");
      return;
    }

    if (!isValidPfShare(formData.pfShare)) {
      alert("PF Share % must be between 0 and 100.");
      return;
    }

    const newEntry = {
      ...formData,
      srNo: dataList.length + 1, // Assign next serial number
    };

    setDataList((prev) => [...prev, newEntry]); // Add at the bottom

    // Reset form
    setFormData({
      srNo: "",
      name: { first: "", second: "", last: "", title: "Select" },
      relation: "",
      dob: "",
      gender: "Select",
      married: "Select",
      employed: "",
      occupation: "",
      dependent: "",
      pfNominee: "",
      pfShare: "",
    });
    setValidationError("");
  };

  // const handleNext = () => {
  //   const employeeId = localStorage.getItem("employeeId");
  //   const userId = sessionStorage.getItem("userId");

  //   const formattedFamilyDetails = dataList.map((entry) => ({
  //     emp_relation: entry.relation,
  //     relation_title: entry.name.title,
  //     relation_first_name: entry.name.first,
  //     relation_second_name: entry.name.second || "", // optional if applicable
  //     relation_last_name: entry.name.last,
  //     relation_dob: entry.dob,
  //     relation_gender: entry.gender,
  //     relation_marital_status: entry.married,
  //     relation_employed: entry.employed,
  //     relation_occupation: entry.occupation,
  //     relation_dependent: entry.dependent,
  //     relation_pf_nominee: entry.pfNominee,
  //     relation_pf_share: entry.pfShare,
  //   }));

  //   const payload = {
  //     created_by: userId,
  //     family_details: formattedFamilyDetails,
  //   };

  //   fetch(
  //     `${ApiUrl.apiurl}STAFF/registrationFamilyRelationCreateUpdate/${employeeId}/`,
  //     {
  //       method: "PUT",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(payload),
  //     }
  //   )
  //     .then((response) => {
  //       if (!response.ok) {
  //         throw new Error("Failed to submit data");
  //       }
  //       return response.json();
  //     })
  //     .then((data) => {
  //       console.log("Submission successful:", data);
  //       goToTab(4);
  //     })
  //     .catch((error) => {
  //       console.error("Error submitting data:", error);
  //       alert("Failed to submit family details.");
  //     });
  // };

  const handleNext = async () => {
    try {
      const hasInvalidPfShare = [formData, ...dataList].some(
        (entry) => !isValidPfShare(entry.pfShare)
      );

      if (hasInvalidPfShare) {
        alert("PF Share % must be between 0 and 100.");
        return;
      }

      const formattedFamilyDetails = [formData, ...dataList]
        .filter(
          (entry) => entry.relation || entry.name?.first || entry.name?.last
        )
        .map((entry) => ({
          emp_relation: entry.relation,
          relation_title: entry.name.title,
          relation_first_name: entry.name.first,
          relation_second_name: entry.name.second || "",
          relation_last_name: entry.name.last,
          relation_dob: entry.dob,
          relation_gender: entry.gender,
          relation_marital_status: entry.married,
          relation_employed: entry.employed,
          relation_occupation: entry.occupation,
          relation_dependent: entry.dependent,
          relation_pf_nominee: entry.pfNominee,
          relation_pf_share: entry.pfShare,
        }));

      sessionStorage.setItem(
        "staff_registration_family",
        JSON.stringify(formattedFamilyDetails)
      );
      goToTab(4);
    } catch (error) {
      console.error("Error while preparing family draft:", error);
      alert("An error occurred while saving family details.");
    }
  };

  useEffect(() => {
    const formattedFamilyDetails = [formData, ...dataList]
      .filter(
        (entry) => entry.relation || entry.name?.first || entry.name?.last
      )
      .map((entry) => ({
        emp_relation: entry.relation,
        relation_title: entry.name.title,
        relation_first_name: entry.name.first,
        relation_second_name: entry.name.second || "",
        relation_last_name: entry.name.last,
        relation_dob: entry.dob,
        relation_gender: entry.gender,
        relation_marital_status: entry.married,
        relation_employed: entry.employed,
        relation_occupation: entry.occupation,
        relation_dependent: entry.dependent,
        relation_pf_nominee: entry.pfNominee,
        relation_pf_share: entry.pfShare,
      }));

    sessionStorage.setItem(
      "staff_registration_family",
      JSON.stringify(formattedFamilyDetails)
    );
  }, [formData, dataList]);

  return (
    <div className="container-fluid">
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Sr.No</th>
              <th>Name</th>
              <th>Relation</th>
              <th>D.O.B</th>
              <th>Gender</th>
              <th>Married</th>
              <th>Employed</th>
              <th>Occupation</th>
              <th>Dependent</th>
              <th>PF Nominee</th>
              <th>% PF Share</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {dataList.map((data, idx) => (
              <tr key={idx}>
                <td>{data.srNo}</td>
                <td>
                  {data.name.title} {data.name.first} {data.name.second}{" "}
                  {data.name.last}
                </td>
                <td>{data.relation}</td>
                <td>{data.dob}</td>
                <td>{data.gender}</td>
                <td>{data.married}</td>
                <td>{data.employed}</td>
                <td>{data.occupation}</td>
                {/* <td>{data.dependent}</td> */}
                <td>{data.dependent === 1 ? "Yes" : "No"}</td>

                <td>{formatPfNominee(data.pfNominee)}</td>

                <td>{data.pfShare}</td>
                <td></td>
              </tr>
            ))}
            <tr>
              <td>{dataList.length + 1}</td>

              <td>
                <select
                  className="form-select mb-1"
                  value={formData.name.title}
                  onChange={(e) =>
                    handleChange("name", e.target.value, "title")
                  }
                >
                  <option>Select</option>
                  <option>Mr</option>
                  <option>Ms</option>
                </select>
                <input
  type="text"
  className="form-control mb-1"
  placeholder="First Name"
  value={formData.name.first}
  onChange={(e) =>
    handleChange(
      "name",
      e.target.value.charAt(0).toUpperCase() +
        e.target.value.slice(1),
      "first"
    )
  }
/>
                <input
  type="text"
  className="form-control mb-1"
  placeholder="Second Name"
  value={formData.name.second}
  onChange={(e) =>
    handleChange(
      "name",
      e.target.value.charAt(0).toUpperCase() +
        e.target.value.slice(1),
      "second"
    )
  }
/>
                <input
  type="text"
  className="form-control"
  placeholder="Last Name"
  value={formData.name.last}
  onChange={(e) =>
    handleChange(
      "name",
      e.target.value.charAt(0).toUpperCase() +
        e.target.value.slice(1),
      "last"
    )
  }
/>
              </td>
              <td>
                <input
                  type="text"
                  className="form-control"
                  value={formData.relation}
                  onChange={(e) => handleChange("relation", e.target.value)}
                />
              </td>
              <td>
                <input
                  type="date"
                  className={`form-control ${validationError ? "is-invalid" : ""}`}
                  value={formData.dob}
                  onChange={(e) => handleChange("dob", e.target.value)}
                />
                {validationError && (
                  <div className="invalid-feedback d-block">
                    {validationError}
                  </div>
                )}
              </td>
              <td>
                <select
                  className="form-select"
                  value={formData.gender}
                  onChange={(e) => handleChange("gender", e.target.value)}
                >
                  <option>Select</option>
                  <option>Male</option>
                  <option>Female</option>
                </select>
              </td>
              <td>
                <select
                  className="form-select"
                  value={formData.married}
                  onChange={(e) => handleChange("married", e.target.value)}
                >
                  <option>Select</option>
                  <option>Yes</option>
                  <option>No</option>
                </select>
              </td>
              <td>
                <div className="form-check form-check-inline me-3">
                  <input
                    type="radio"
                    className="form-check-input"
                    name="employed"
                    value="Yes"
                    checked={formData.employed === "Yes"}
                    onChange={(e) => handleChange("employed", e.target.value)}
                  />
                  <label className="form-check-label">Yes</label>
                </div>
                <br></br>
                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    className="form-check-input"
                    name="employed"
                    value="No"
                    checked={formData.employed === "No"}
                    onChange={(e) => handleChange("employed", e.target.value)}
                  />
                  <label className="form-check-label">No</label>
                </div>
              </td>

              <td>
                <input
                  type="text"
                  className="form-control"
                  value={formData.occupation}
                  onChange={(e) => handleChange("occupation", e.target.value)}
                />
              </td>
              <td>
                <div className="form-check">
                  <input
                    type="radio"
                    className="form-check-input"
                    name="dependent"
                    value={1}
                    checked={formData.dependent === 1}
                    onChange={() => handleChange("dependent", 1)}
                  />
                  <label className="form-check-label">Yes</label>
                </div>
                <br />
                <div className="form-check">
                  <input
                    type="radio"
                    className="form-check-input"
                    name="dependent"
                    value={0}
                    checked={formData.dependent === 0}
                    onChange={() => handleChange("dependent", 0)}
                  />
                  <label className="form-check-label">No</label>
                </div>
              </td>

              <td>
                <div className="form-check">
                  <input
                    type="radio"
                    className="form-check-input"
                    name="pfNominee"
                    value="T"
                    checked={formData.pfNominee === "T"}
                    onChange={(e) => handleChange("pfNominee", e.target.value)}
                  />
                  <label className="form-check-label">Yes</label>
                </div>
                <br></br>
                <div className="form-check">
                  <input
                    type="radio"
                    className="form-check-input"
                    name="pfNominee"
                    value="F"
                    checked={formData.pfNominee === "F"}
                    onChange={(e) => handleChange("pfNominee", e.target.value)}
                  />
                  <label className="form-check-label">No</label>
                </div>
              </td>
              <td>
                <input
                  type="text"
                  className="form-control"
                  value={formData.pfShare}
                  onChange={(e) => handleChange("pfShare", e.target.value)}
                />
              </td>
              <td>
                <button className="btn btn-primary" onClick={handleAdd}>
                  Add
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-between mb-3 mt-3"></div>
    </div>
  );
};

export default App;






